// extracted by mini-css-extract-plugin
export default {"radio-group":"radio-group_radio-group__2hUNO","label":"radio-group_label__jwNWL"};